import React from "react";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";

export default function VitalsTrendChart({ vitalsTrend }) {
  if (!vitalsTrend || !vitalsTrend.dates || vitalsTrend.dates.length < 2) {
    return <p className="py-6 text-center text-xs text-muted-foreground">Need at least 2 consultations for trend data.</p>;
  }

  const data = vitalsTrend.dates.map((d, i) => ({
    date: d,
    Weight: vitalsTrend.weight[i],
    "BP Sys": vitalsTrend.bp_systolic[i],
    "BP Dia": vitalsTrend.bp_diastolic[i],
    BMI: vitalsTrend.bmi[i],
  }));

  return (
    <div className="space-y-4">
      <div className="rounded-lg border border-navy/10 bg-white p-4">
        <p className="mb-2 text-xs font-semibold uppercase tracking-wider text-muted-foreground">Weight & BMI</p>
        <ResponsiveContainer width="100%" height={180}>
          <LineChart data={data}>
            <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" />
            <XAxis dataKey="date" tick={{ fontSize: 10 }} stroke="#9CA3AF" />
            <YAxis tick={{ fontSize: 10 }} stroke="#9CA3AF" />
            <Tooltip contentStyle={{ fontSize: 12 }} />
            <Legend wrapperStyle={{ fontSize: 11 }} />
            <Line type="monotone" dataKey="Weight" stroke="#1B3A5C" strokeWidth={2} dot={{ r: 3 }} connectNulls />
            <Line type="monotone" dataKey="BMI" stroke="#C49A6C" strokeWidth={2} dot={{ r: 3 }} connectNulls />
          </LineChart>
        </ResponsiveContainer>
      </div>

      <div className="rounded-lg border border-navy/10 bg-white p-4">
        <p className="mb-2 text-xs font-semibold uppercase tracking-wider text-muted-foreground">Blood Pressure</p>
        <ResponsiveContainer width="100%" height={180}>
          <LineChart data={data}>
            <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" />
            <XAxis dataKey="date" tick={{ fontSize: 10 }} stroke="#9CA3AF" />
            <YAxis tick={{ fontSize: 10 }} stroke="#9CA3AF" />
            <Tooltip contentStyle={{ fontSize: 12 }} />
            <Legend wrapperStyle={{ fontSize: 11 }} />
            <Line type="monotone" dataKey="BP Sys" stroke="#B91C1C" strokeWidth={2} dot={{ r: 3 }} connectNulls />
            <Line type="monotone" dataKey="BP Dia" stroke="#C49A6C" strokeWidth={2} dot={{ r: 3 }} connectNulls />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
